module.exports = __webpack_public_path__ + "assets/icon-non-filter-component.08aa6398.svg";